import { Methodology as MyType } from '@shapeable/lli-types';
import { EntityConfig, entityStandardFormFields } from '@shapeable/core';

export const Methodology: EntityConfig<MyType> = {
  name: 'Methodology',
  label: 'Methodology',
  type: 'taxonomy',
  includeInSearch: true,
  list: {
    resultsVariant: 'list',
  },
  autoRoutes: ['create', 'update', 'list'],
  
  form: {
    fields: {
      ...entityStandardFormFields,
      label: { type: 'text' },
      description: { type: 'longText' },
    }
  },
}; 